import { Component, inject, input } from '@angular/core';
import {
  PersonSimpleWithRole,
  ProjectPublicResponse,
} from '@app/models/project.models';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NamePositionEmailDisplayComponent } from '../name-position-email-display/name-position-email-display.component';
import { NamePositionEmailData } from '../name-position-email-display/name-position-email-display.models';
import { SpecialEntityContactsComponent } from '../special-entity-contacts/special-entity-contacts.component';

@Component({
  selector: 'app-project-details-section-e',
  imports: [
    TranslatePipe,
    CardComponent,
    LabeledContentComponent,
    SpecialEntityContactsComponent,
    NamePositionEmailDisplayComponent,
  ],
  templateUrl: './project-details-section-e.component.html',
  styleUrl: './project-details-section-e.component.scss',
  providers: [GetLocalizedPipe],
})
export class ProjectDetailsSectionEComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  protected translationKey = 'projectDetails.sectionE.';
  private genericStore = inject(GenericStore);

  constructor(private localizedPipe: GetLocalizedPipe) {}

  private titlePrefix(person: PersonSimpleWithRole): string {
    if (person.titleCode === null) return '';
    const entity = this.genericStore
      .nameTitlesEntities()
      .find(
        (t) => t.code === person.titleCode || t.id === person.titleCode,
      );
    if (entity !== undefined) {
      return (this.localizedPipe.transform(entity.localized) || '').trim();
    }
    return person.titleCode;
  }

  protected getPersonData(person: PersonSimpleWithRole): NamePositionEmailData {
    let name = '';
    const prefix = this.titlePrefix(person);
    if (prefix !== '') {
      name = prefix + ' ';
    }
    name += person.firstName;
    if (person.midName !== null) {
      name += ' ' + person.midName;
    }
    name += ' ' + person.lastName;
    return {
      name,
      position: person.position ?? null,
      email: person.email ?? null,
    };
  }
}
